// extracted by mini-css-extract-plugin
module.exports = {"share_panel_padding_top":"0.47rem"};